import React from 'react';
var WPElement = require('@wordpress/element');
import Display from './components/Display';
var rootElement = document.getElementById('partnersgrid-block-root');
if (rootElement) {
    WPElement.render(React.createElement(Display, null), document.getElementById('partnersgrid-block-root'));
}
